import type { ActivityModule } from '../../core/activity';
import { mountAdjacentNumbers } from './ui';
import levelsData from './levels.json';
import './style.css';

export const adjacentNumbers: ActivityModule = {
  id: 'adjacent_numbers',
  title: 'Números vizinhos',
  description: 'Descubra os números que faltam na sequência. Toque num número embaixo e depois no espaço vazio.',
  ageMin: 5,
  ageMax: 9,
  difficulty: 1,
  iconPath: 'assets/gcompris-AGPL/adjacent_numbers/icon.svg',
  category: 'numeracao',
  totalLevels: levelsData.levels.length,
  mount: mountAdjacentNumbers,
};
